import { LitElement, html, css } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { router } from '../router';
import { AuthService } from '../services/auth-service';





@customElement('app-login')
export class AppLogin extends LitElement {
  @state() private username: string = '';
  @state() private password: string = '';
  @state() private errorMessage: string = '';
  @state() private isLoading: boolean = false;

  static styles = css`
    :host {
      display: block;
      font-family: 'Arial', sans-serif;
      text-align: center;
      height: 100vh;
      position: relative;
      overflow: hidden;
    }

    .background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url('/assets/background_loggin.jpg') no-repeat center center;
      background-size: cover;
      filter: grayscale(70%) brightness(80%);
      z-index: -1; /* Keep background behind content */
    }
.background::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.3); /* Semi-transparent white overlay */
  z-index: -1; /* Ensure it stays below content */
}

    .login-container {
      position: relative;
      background: rgba(255, 255, 255, 0.9);
      padding: 24px;
      border-radius: 10px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
      width: 90%;
      max-width: 360px;
      margin: auto;
      top: 50%;
      transform: translateY(-50%);
      z-index: 1;
    }

    .login-container h2 {
      font-size: 2rem;
      color: #003366; /* NAV Portugal navy blue */
      margin-bottom: 24px;
    }

    .form-group {
      margin-bottom: 16px;
    }

    .form-group label {
      font-size: 0.9rem;
      color: #666;
      margin-bottom: 4px;
      display: block;
    }

    input {
      width: 100%;
      padding: 12px;
      border: 1px solid #ddd;
      border-radius: 6px;
      font-size: 1rem;
      box-sizing: border-box;
    }

    input:focus {
      border-color: #003366;
      outline: none;
      box-shadow: 0 0 5px rgba(0, 51, 102, 0.4);
    }

    button {
      width: 100%;
      background: #003366;
      color: white;
      border: none;
      padding: 12px;
      border-radius: 6px;
      font-size: 1rem;
      cursor: pointer;
      margin-top: 16px;
      font-weight: bold;
      transition: background-color 0.3s ease;
    }

    button:hover:not([disabled]) {
      background: #00509e; /* Slightly lighter navy tone */
    }

    button[disabled] {
      background: #a8a8a8;
      cursor: not-allowed;
    }

    .error {
      color: #ff4d4d;
      font-size: 0.9rem;
      margin-top: 16px;
    }

    .footer {
      margin-top: 24px;
      font-size: 0.8rem;
      color: #aaa;
    }

    .footer a {
      color: #00509e;
      text-decoration: none;
    }

    .footer a:hover {
      text-decoration: underline;
    }

    @media (max-width: 480px) {
      .login-container {
        padding: 16px;
      }

      .login-container h2 {
        font-size: 1.5rem;
      }
    }
  `;




  private async handleLogin() {
    this.errorMessage = '';
    this.isLoading = true;

    try {
      const workerNumber = await AuthService.authenticate(this.username, this.password);

      if (workerNumber) {
        router.navigate('/home');
      } else {
        this.errorMessage = 'Invalid credentials. Please try again.';
      }
    } catch (error) {
      console.error('Login error:', error);
      this.errorMessage = 'Something went wrong. Please try again.';
    } finally {
      this.isLoading = false;
    }
  }

  render() {
    return html`
      <div class="background"></div>
      <div class="login-container">
        <div class="form-group">
          <label for="username">Username</label>
          <input
            id="username"
            type="text"
            aria-label="Enter your username"
            placeholder="Enter your username"
            .value=${this.username}
            @input=${(e: Event) => (this.username = (e.target as HTMLInputElement).value)}
          />
        </div>
        <div class="form-group">
          <label for="password">Password</label>
          <input
            id="password"
            type="password"
            aria-label="Enter your password"
            placeholder="Enter your password"
            .value=${this.password}
            @input=${(e: Event) => (this.password = (e.target as HTMLInputElement).value)}
          />
        </div>
        <button ?disabled=${this.isLoading} @click=${this.handleLogin}>
          ${this.isLoading ? 'Logging in...' : 'Login'}
        </button>
        ${this.errorMessage
          ? html`<p class="error">${this.errorMessage}</p>`
          : ''}
      </div>
    `;
  }
}
